export class GetFrontBackComparisonReqData {

    public installationName: string = null;
    public startDate: Date = null;
    public endDate: Date = null;

    constructor() { }

}